import type { Handbook } from '../../../types/handbook';
import { HandbookEvents } from '../../../helpers/events/handbookEvents';

export const sendHandbookEvent = (
  handbook: Handbook | null
) => {
  document.dispatchEvent(
    new CustomEvent(HandbookEvents.handbookInit, {
      detail: handbook
    })
  );
};
